import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { HalfYear } from "api/generated/model";
import { GenericMultiCheckboxes } from "org/control/list/controls/common/genericMultiCheckboxes";

type OnChangeCallback = (key: HalfYear, value: boolean) => void;

interface CommonProps {
    halfYears: Record<HalfYear, boolean[]>;
}
type EditProps = CommonProps & { onChange: OnChangeCallback };
type ReadOnlyProps = CommonProps;
type MultiHalfYearlyCheckboxesProps =
    | ({ type: "EDIT" } & EditProps)
    | ({ type: "READ_ONLY" } & ReadOnlyProps);

function MultiHalfYearlyCheckboxes(props: MultiHalfYearlyCheckboxesProps) {
    const { labels, allLabel } = prepareLabels(i18next.language);

    switch (props.type) {
        case "EDIT": {
            const { halfYears, onChange } = props;
            return (
                <GenericMultiCheckboxes
                    type="EDIT"
                    labels={labels}
                    allLabel={allLabel}
                    values={halfYears}
                    onChange={onChange}
                />
            );
        }
        case "READ_ONLY": {
            const { halfYears } = props;
            return (
                <GenericMultiCheckboxes
                    type="READ_ONLY"
                    labels={labels}
                    allLabel={allLabel}
                    values={halfYears}
                />
            );
        }
        default: {
            return assertNever(props);
        }
    }
}

// Pass language (although it's not used explicitly) to ensure memoizeOne resets the cache
// if the language changes.
const prepareLabels = memoizeOne((_language: string) => {
    return {
        labels: {
            First: t("Half_1"),
            Second: t("Half_2"),
        },
        allLabel: t("CreateControl_Recurrence_ScheduleAllHalfYears"),
    };
});

export { MultiHalfYearlyCheckboxes, type MultiHalfYearlyCheckboxesProps };
